import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointLg} from "@/tokens/variables";

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`
    :host {
        display: block;
        --tab-menu__fade-color: var(--_tab-menu__fade-color, var(--sbkColorContentBgColorDefault));
    }

    ::slotted(sbk-tab-menu-item) {
        display: inline-block;
    }
    
    .container {
        position: relative;
    }

    .tab_container {
        display: flex;
        align-items: flex-end;
        gap: var(--sbkTargetgroupsSpacingSmallScrGap);
        overflow-x: auto;
        padding: 0;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;

        &::-webkit-scrollbar {
            display: none;
        }
        
        @media screen and (min-width: ${breakpointLg}) {
            gap: var(--sbkTargetgroupsSpacingLargeScrGap);
        }
    }

    .align-items--left {
        justify-content: flex-start;
    }

    .align-items--center {
        justify-content: center;
    }

    .align-items--right {
        justify-content: flex-end;
    }

    .fade {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 20%;
        pointer-events: none;
        z-index: 1;
    }

    .fade-left {
        left: 0;
        background: linear-gradient(to right, var(--tab-menu__fade-color), rgba(255, 255, 255, 0));
    }

    .fade-right {
        right: 0;
        background: linear-gradient(to left, var(--tab-menu__fade-color), rgba(255, 255, 255, 0));
    }
`;
